// extracted by mini-css-extract-plugin
module.exports = {"header-icon-wrapper":"HeaderIcon_header-icon-wrapper__RqXC6"};